<template>
  <div class="bjlsc">
    <headerBanner :bannerUrl='bannerUrl'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i6"></i></div><p>{{cate.name}}</p>
    </div>

    <div class="xmtd_detail">
      <img :src="domain+cate.litpic" alt="">
      <!-- <template v-for='item in data'>
          <div class="xmtd_leader clearfix" v-if='item.id=="15"'>
            <div class="xmtd_leader_title">安永项目团队</div>
            <div class="xmtd_leader_item clearfix" v-for='items in item.art'>
              <img :src="domain+items.litpic" alt="">
              <div class="xmtd_leader_item_text">
                <p class="c_name">{{items.title}}</p>
                <p class="e_name">{{items.shorttitle}}</p>
                <p class="zw" v-html='items.copyfrom'></p>
              </div>
            </div>
          </div>
          
          <div class="xmtd_area fd clearfix" v-if='item.id=="19"'>
            <div class="area_name sp">
              复旦项目团队
            </div>
            <template v-for='items in item.art'>
              <div class="clearfix leader" v-if='items.commentflag=="1"'>
                <div class="xmtd_area_leader clearfix">
                  <div class="img_wrap">
                    <img :src="domain+items.litpic" alt="">
                  </div>
                  <div class="xmtd_leader_item_text">
                    <p class="c_name">{{items.title}}</p>
                    <p class="e_name">{{items.shorttitle}}</p>
                    <p class="zw" v-html='items.copyfrom'></p>
                  </div>
                </div>
              </div>
              <div class="xmtd_area_leader clearfix" v-else>
                <div class="img_wrap">
                  <img :src="domain+items.litpic" alt="">
                </div>
                <div class="xmtd_leader_item_text">
                   <p class="c_name">{{items.title}}</p>
                   <p class="e_name">{{items.shorttitle}}</p>
                   <p class="zw" v-html='items.copyfrom'></p>
                </div>
              </div>
            </template> 
          </div>
          <div class="xmtd_area xny clearfix" v-if='item.id=="39"'>
            <div class="area_name sp">
              行业顾问小组-新能源
            </div>
            <template v-for='items in item.art'>
              <div class="clearfix leader" v-if='items.commentflag=="1"'>
                <div class="xmtd_area_leader clearfix">
                  <div class="img_wrap">
                    <img :src="domain+items.litpic" alt="">
                  </div>
                  <div class="xmtd_leader_item_text">
                    <p class="c_name">{{items.title}}</p>
                    <p class="e_name">{{items.shorttitle}}</p>
                    <p class="zw" v-html='items.copyfrom'></p>
                  </div>
                </div>
              </div>
              <div class="xmtd_area_leader clearfix" v-else>
                <div class="img_wrap">
                  <img :src="domain+items.litpic" alt="">
                </div>
                <div class="xmtd_leader_item_text">
                   <p class="c_name">{{items.title}}</p>
                   <p class="e_name">{{items.shorttitle}}</p>
                   <p class="zw" v-html='items.copyfrom'></p>
                </div>
              </div>
            </template> 
          </div>
          <div class="xmtd_area hb clearfix" v-if='item.id=="16"'>
            <div class="area_name">
              华北区
            </div>
            <template v-for='items in item.art'>
              <div class="clearfix leader" v-if='items.commentflag=="1"'>
                <div class="xmtd_area_leader clearfix">
                  <div class="img_wrap">
                    <img :src="domain+items.litpic" alt="">
                  </div>
                  <div class="xmtd_leader_item_text">
                    <p class="c_name">{{items.title}}</p>
                    <p class="e_name">{{items.shorttitle}}</p>
                    <p class="zw" v-html='items.copyfrom'></p>
                  </div>
                </div>
              </div>
              <div class="xmtd_area_leader clearfix" v-else>
                <div class="img_wrap">
                  <img :src="domain+items.litpic" alt="">
                </div>
                <div class="xmtd_leader_item_text">
                   <p class="c_name">{{items.title}}</p>
                   <p class="e_name">{{items.shorttitle}}</p>
                   <p class="zw" v-html='items.copyfrom'></p>
                </div>
              </div>
            </template> 
          </div>
        
          <div class="xmtd_area hz clearfix" v-if='item.id=="17"'>
            <div class="area_name">
              华中区
            </div>
            <template v-for='items in item.art'>
              <div class="clearfix leader" v-if='items.commentflag=="1"'>
                <div class="xmtd_area_leader clearfix">
                  <div class="img_wrap">
                    <img :src="domain+items.litpic" alt="">
                  </div>
                  <div class="xmtd_leader_item_text">
                    <p class="c_name">{{items.title}}</p>
                    <p class="e_name">{{items.shorttitle}}</p>
                    <p class="zw" v-html='items.copyfrom'></p>
                  </div>
                </div>
              </div>
              <div class="xmtd_area_leader clearfix" v-else>
                <div class="img_wrap">
                  <img :src="domain+items.litpic" alt="">
                </div>
                <div class="xmtd_leader_item_text">
                   <p class="c_name">{{items.title}}</p>
                   <p class="e_name">{{items.shorttitle}}</p>
                   <p class="zw" v-html='items.copyfrom'></p>
                </div>
              </div>
            </template> 
          </div>
        
          <div class="xmtd_area hn clearfix" v-if='item.id=="18"'>
            <div class="area_name">
              华南区
            </div>
            <template v-for='items in item.art'>
              <div class="clearfix leader" v-if='items.commentflag=="1"'>
                <div class="xmtd_area_leader clearfix">
                  <div class="img_wrap">
                    <img :src="domain+items.litpic" alt="">
                  </div>
                  <div class="xmtd_leader_item_text">
                    <p class="c_name">{{items.title}}</p>
                    <p class="e_name">{{items.shorttitle}}</p>
                    <p class="zw" v-html='items.copyfrom'></p>
                  </div>
                </div>
              </div>
              <div class="xmtd_area_leader clearfix" v-else>
                <div class="img_wrap">
                  <img :src="domain+items.litpic" alt="">
                </div>
                <div class="xmtd_leader_item_text">
                   <p class="c_name">{{items.title}}</p>
                   <p class="e_name">{{items.shorttitle}}</p>
                   <p class="zw" v-html='items.copyfrom'></p>
                </div>
              </div>
            </template> 
          </div>

        </template> -->
    </div>
    <div class="hzjg">
      <div class="hzjg_content">
        <div class="hzjg_title">
          <span>复旦大学管理学院</span>
          <!-- <img src="../../static/images/hzdw.png" alt=""> -->
        </div>
        <div class="hzjg_detail">
          <div v-html="cate.content"></div>
          <!-- <p>中国金融信息中心是新华社直属机构，是新华社和上海市人民政府战略合作的重大成果，既服务于上海国际金融中心建设的国家战略，同时服务于新华社打造国际一流新型世界性通讯社的战略目标，是陆家嘴金融城的标志性建筑和上海国际金融中心建设的功能性平台。</p>
          <p>中国金融信息中心集金融服务、会展企划、教育培训、信息发布、市值管理、线上传播、品牌推广、平台建设、空间运营、资本运作等多重功能于一身，努力将自身打造成为一个“开放、服务、共享、多赢”的专业化、国际化的多功能平台。</p>
          <p>中国金融信息中心依托新华社在政治、品牌、渠道、人脉、信息、网络、人才等方面的综合优势，并发挥入驻机构和战略伙伴的强大功能，立足上海，辐射长三角，服务全国，接轨世界，在服务中创造价值，铸就品质，打造核心竞争力。</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'zxxy',
  data () {
    return {
      data: [],
      domain:'https://eympe.vapps.me',
      bannerUrl:'',
      cate:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_category',
       {
          cid:14
        },
       {emulateJSON : true})
   .then((response) => {
         var data=response.body.data
         this.cate = response.body.cate;
         this.bannerUrl = this.domain+response.body.cate.bgpic
         console.log(response)
         for(var i=0;i<data.length;i++){
            for(var j=0;j<data[i].art.length;j++){
              //console.log(data[i].art[j].copyfrom)
              data[i].art[j].copyfrom = htmlDecodeByRegExp(data[i].art[j].copyfrom)
            }
           //console.log(data[i])
            //data[i].copyfrom = htmlDecodeByRegExp(data[i].copyfrom)
         }
         this.data = data;
         function htmlDecodeByRegExp(str){  
               var s = "";
               if(str.length == 0) return "";
               s = str.replace(/&amp;/g,"&");
               s = s.replace(/&lt;/g,"<");
               s = s.replace(/&gt;/g,">");
               s = s.replace(/&nbsp;/g," ");
               s = s.replace(/&#39;/g,"\'");
               s = s.replace(/&quot;/g,"\"");
               return s;  
         }
     })
  }
}
</script>

<style scoped>
  .hzjg{
    padding: 0 0.42rem 0 0.32rem;
  }
  .hzjg_content{
    border:0.03rem solid #ffd200;
    border-radius: 0.06rem;
    position: relative;
  }
  .hzjg_title{
    font-size: 0.24rem;
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    left: 0.25rem;
    padding: 0 0.14rem;
    background-color: #fff;
    z-index: 9
  }
  .hzjg_title span{
    vertical-align: middle;
    color: #6d6e71;
    display:inline-block;
    text-decoration: underline;
  }
  .hzjg_title img{
    width: 2.45rem;
    vertical-align: middle;
    margin-bottom: 0.1rem;
    margin-left: 0.1rem;
  }
  .hzjg_detail{
    padding: 0.3rem;
    font-size: 0.2rem;
    color: #231f20;
    /* margin-bottom: 0.2rem; */
  }
  .hzjg_detail p:last-child{
    margin-bottom: 0;
  }
  i.i6{
    width: 0.4rem;
    height: 0.4rem;
    background-position: -1.45rem -0.82rem;
  }
  .xmtd_detail{
    padding: 0 0.2rem;
    margin-bottom: 0.4rem;
  }
  .xmtd_leader{
    margin-bottom: 0.4rem;
  }
  .xmtd_leader_title{
    font-size: 0.25rem;
    color: #010101;
    margin-bottom: 0.16rem;
    padding-bottom: .16rem;
    border-bottom: 1px solid #ffd204
  }
  .xmtd_leader_item{
    float: left;
    width: 50%;
    height: 1.12rem;
    margin-bottom: 0.26rem;
  }
  .xmtd_leader_item img{
    width: 0.8rem;
    border:0.02rem solid #ffd204;
    border-bottom: 0.07rem solid #ffd204;
    float: left;
  }
  .xmtd_leader_item_text{
    width: 2.1rem;
    float: right;
    font-size: 0.18rem;
    color: #000;
  }
  .xmtd_area_leader{
    width: 50%;
    float: left;
    margin-bottom: 0.26rem;
    height: 1.2rem;
  }
  .xmtd_area_leader img{
    width: 0.8rem;
    border:0.01rem solid #ffd204;
    display: block;
    border-bottom: 0.07rem solid #ffd204;
  }
  .img_wrap{
    float: left;

  }
  .area_name{
    padding-bottom: 0.16rem;
    font-size: 0.2213rem;
    color: #010101;
    border-bottom:1px solid #ef4b3e;
    margin-bottom: 0.17rem;
  }
  .area_name.sp{
    font-size: 0.25rem
  }
  .xmtd_area_leader .img_wrap img{
    border:none;
  }
  .hb .xmtd_area_leader .img_wrap img{
    border:0.01rem solid #ef4b3e;
  }
  .hb .leader .xmtd_area_leader .img_wrap{
    border-bottom: 0.07rem solid #ffd204;
  }
  .hz .xmtd_area_leader .img_wrap img{
    border:0.01rem solid #92278f;
  }
  .hz .leader .xmtd_area_leader .img_wrap{
    border-bottom: 0.07rem solid #ffd204;
  }
  .hz .area_name{
     border-bottom:1px solid #92278f;
  }
  .hn .xmtd_area_leader .img_wrap img{
    border:0.01rem solid #2c973e;
  }
  .hn .leader .xmtd_area_leader .img_wrap{
    border-bottom: 0.07rem solid #ffd204;
  }
  .hn .area_name{
     border-bottom:1px solid #2c973e;
  }
  .fd .xmtd_area_leader .img_wrap img{
    border:0.01rem solid #ffd204;
  }
  .fd .leader .xmtd_area_leader .img_wrap{
    border-bottom: 0.07rem solid #ffd204;
  }
  .fd .area_name{
     border-bottom:1px solid #ffd204;
  }
  .xny .xmtd_area_leader .img_wrap img{
    border:0.01rem solid rgb(0,138,203);
  }
  .xny .leader .xmtd_area_leader .img_wrap{
    border-bottom: 0.07rem solid rgb(0,138,203);
  }
  .xny .area_name{
     border-bottom:1px solid rgb(0,138,203);
  }
  .e_name{
    font-family: EY_Regular;
  }
</style>
<style>
  .hzjg_detail p,.hzjg_detail span,.hzjg_detail div{
    font-size: 0.2rem !important;
    color: #231f20 !important;
    margin-bottom: 0.2rem !important;
  }
  .hzjg_detail *:empty{
    display: none;
  }
  .hzjg_detail p:last-child{
    margin-bottom: 0 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/xmtd.vue